// 19.1.2.7 Object.getOwnPropertyNames(O)
require('./_object-sap')('getOwnPropertyNames', function () {
  return require('./_object-gopn-ext').f;
});



//////////////////
// WEBPACK FOOTER
// /home/runner/work/onelocal/onelocal/src/my-referral/~/.pnpm/core-js@2.6.12/~/core-js/modules/es6.object.get-own-property-names.js
// module id = ../../../../../../core-js@2.6.12/node_modules/core-js/modules/es6.object.get-own-property-names.js
// module chunks = 0